<div #icon class="icon"></div>
<div #text class="text">CHARGEMENT...</div>
<span style="font-family:'Calibri';font-weight:normal"></span><span style="font-family:'Calibri';font-weight:italic"></span>
<span style="font-family:'NotoSansMono';font-weight:normal"></span><span style="font-family:'NotoSansMono';font-weight:bold"></span>
<span style="font-family:'Quantico';font-weight:normal"></span><span style="font-family:'Quantico';font-weight:bold"></span>
<span style="font-family:'Montserrat';font-weight:normal"></span><span style="font-family:'Montserrat';font-weight:500"></span>
<span style="font-family:'Orbitron';font-weight:800"></span>
<span style="font-family:'VT323';font-weight:normal"></span>